import { render } from "./SalesVoucherList.vue?vue&type=template&id=8aad70a8"
import script from "./SalesVoucherList.vue?vue&type=script&lang=js"
export * from "./SalesVoucherList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__